import styled from 'styled-components';
import { FlexColumn } from '@equifinance/shared';
import { Application } from '../../../contexts/applications';

const AlertIcon = styled.i`${({ theme }) => `
  color: ${theme.colours.danger[1]};
  font-size: ${theme.fontSize[7]};
`}`;

const ReferenceColumnContainer = styled(FlexColumn)`
  width: 100%;
  max-width: 100%;
  align-items: center;
`;

export default function ReferenceColumn({ row }: { row: Application }) {
  const showAlert: boolean = !!row.tasks.find((task) => task.updated);
  return (
    <ReferenceColumnContainer>
      {showAlert && (
        <AlertIcon className="mi-notification" />
      )}
      {row.reference || '-'}
    </ReferenceColumnContainer>
  );
}
